// payroll list filter
export const SET_PAYROLL_LIST_FILTER = "SET_PAYROLL_LIST_FILTER";